
import './digital-courses.scss';
import React, { useLayoutEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { Trans, useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router';
import StopMotionSvg from '../../components/StopMotionSvg';
import DashedDrawedSvg from '../../components/DashedDrawedSvg';
import * as images from './digital-courses-media'
import CommonVideo from '../../components/common/common-video';
import CommonButton from '../../components/button/button';
import ModalOpenButton from '../../components/common/modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import useDeviceDetection from '../../hooks/useDeviceDetection';


function DigitalCourses() {
    const { reloadState, relativeVh } = useOutletContext();

    const { t } = useTranslation();
    const [isRtl, setIsRtl] = useState(1);
    const [intervalSection2, setIntervalSection2] = useState(null);
    const deviceType = useDeviceDetection();

    useLayoutEffect(() => {
        window.scrollTo({ top: 0 });
        reloadState[1](false);
    }, []);

    useGSAP(() => {

        //#region section 1

        gsap.to('#digital-courses-header', {
            scrollTrigger: {
                trigger: '#section1',
                start: 'top top',
                end: 'bottom top',
                scrub: true,
            },
            scale: 0.61
        });
        //#endregion

        //#region section 2
        const tl = gsap.timeline();
        ScrollTrigger.create({
            animation: tl,
            trigger: '.section-2',
            start: "top 70%",
            end: '10% 20%',
            scrub: true
        });
        tl.fromTo(".section-2 .row .item",
            {
                autoAlpha: 0,
                y: 100,
            },
            {
                autoAlpha: 1,
                y: 0,
                duration: 1,
                stagger: .35
            }
        )
            .add(() => setIntervalSection2(i => !i ? 400 : null), '-=0.2')

        //#endregion



        //#region section 13 -  prouductions row go up on e after onother

        const boxesTl = gsap.timeline();

        ScrollTrigger.create({
            animation: boxesTl,
            trigger: '.section-13',
            endTrigger: '.section-13 .sub-title',
            start: "top 70%",
            end: 'top 20%',
            scrub: true
        });

        boxesTl.fromTo(".section-13 .productions .box",
            {
                autoAlpha: 0,
                y: 30,
            },
            {
                autoAlpha: 1,
                y: 0,
                stagger: .5,
                ease: 'power1.out'
            }
        )

        //#endregion
        gsap.timeline({ repeat: -1 })
            .set('.section-14-images img.dinoman', { scaleX: 1 }, 0)
            .set('.section-14-images img.dinoman', { scaleX: -1, x: 60 }, 0.75)
            .set('.section-14-images img.dinoman', { scaleX: 1 }, 1.5)

        //#region dancing items

        gsap.timeline({ repeat: -1 })
            .to('.key', { scale: 1.2 }, 0)
            .to('.key', { scale: 1 }, 1.4)

        gsap.timeline({ repeat: -1 })
            .to('.play-circle-button, .button', { scale: 1.3 }, 0)
            .to('.play-circle-button, .button', { scale: 1 }, 1.2)

        //#endregion


        setTimeout(() => {
            // Ensure ScrollTrigger recalculates positions
            ScrollTrigger.refresh();
        }, 100);

    }, { dependencies: [] })



    return (
        <div className='digital-courses-component'>

            {/* section 1 */}
            <section id="section-1" className='section-1'>
                <h1 id="digital-courses-header" className='headline'>
                    <Trans i18nKey={'digital-courses.digital courses'}>
                        <span className='intro-title'></span>
                    </Trans>
                </h1>
            </section>

            {/* section 2 */}
            <section className='section-2' id="section2">
                <div className='sub-title'>
                    <Trans i18nKey="digital-courses.Who are our courses aimed at?">
                        Who are our <span className='marked-text'>courses</span> aimed at?
                    </Trans>
                </div>
                <div className='courses-types' id='courses-types'>
                    <div className="row">
                        {images.section2Images.map((item, index) => (
                            <div className="item" key={`item${index}`}>
                                <div
                                    className='dancing-lines-container'
                                    style={{
                                        marginInline: item.marginInline,
                                        marginBlock: item.marginBlock,
                                        ...(item.justifyContent && { justifyContent: item.justifyContent })
                                    }}
                                >
                                    <StopMotionSvg
                                        shapes={item.shapes}
                                        width={item.width}
                                        height={item.height}
                                        interval={intervalSection2}
                                    />
                                </div>
                                <div className={`related-image ${item.name}`}>
                                    <img src={item.img} alt={t(`digital-courses.section-2.${item.description}`)} />
                                </div>
                                <p className={`${item.name}-p text-run`}>
                                    {t(`digital-courses.section-2.${item.description}`)}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* section 3 */}
            {deviceType?.isMobile ? (
                <div className="mobile-dash-line" id="mobile-dash-line-1">
                    <DashedDrawedSvg
                        svgWidth="201" svgHeight="195"
                        d="M53.6362 13.7733C0.366603 39.2007 162.72 60.7578 78.4956 97.4661C41.6465 113.526 140.396 182.681 156.821 182.894"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-1' startTrigger="top 95%" endTrigger="bottom 10%" />
                </div>
            ) : (
                <section className='section-3' id="section3">
                    <div className='transition-1' id="transition-1">
                        <DashedDrawedSvg
                            svgWidth='180' svgHeight='249' strokeDasharray='540'
                            d='M25.5102 4.21571C-68.2298 47.111 200.099 85.6939 55.0369 147.079C-8.42931 173.936 157.302 242.156 178.946 243.761'
                            trigger='#section3' startTrigger="top 85%" endTrigger="bottom 20%" />
                    </div>
                </section>
            )}

            {/* section 4 */}
            <section className='section-4' id="section4">
                <div className='text-run'>
                    <Trans i18nKey={'digital-courses.section-4.Corona brought with it - face masks,'}>
                        <span className='sub-title'></span>
                    </Trans>
                </div>
                <img src={images.manWithMaskSection4} alt='' />
            </section>
            {deviceType?.isMobile && (
                <div className="mobile-dash-line" id="mobile-dash-line-2">
                    <DashedDrawedSvg
                        svgWidth="84" svgHeight="115"
                        d="M40.4413 2.6748C20.2746 21.5081 -12.9587 61.9748 15.4413 73.1748C43.501 84.2406 111.001 69 64.9404 111.675"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-2' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            )}

            {/* section 5 */}
            <section className='section-5' id="section5">
                <div className='text-run'>
                    <Trans i18nKey={'digital-courses.Increase in sales of alcohol gel'}>
                        <span className='sub-title'></span>
                    </Trans>
                </div>
                <div className="korona-contener">
                    {images.backgroundSection5}
                    <img src={deviceType?.isMobile ? images.alcoholGelManSection5Mobile : images.alcoholGelManSection5} alt='' />

                </div>
            </section>
            {deviceType?.isMobile && (
                <div className="mobile-dash-line" id="mobile-dash-line-3">
                    <DashedDrawedSvg
                        svgWidth="84" svgHeight="115"
                        d="M43.5587 2.6748C63.7254 21.5081 96.9587 61.9748 68.5587 73.1748C40.499 84.2406 -27.001 69 19.0596 111.675"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-3' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            )}

            {/* section 6 */}
            <section className='section-6' id="section6">
                <div className='flex'>
                    <img src={images.virtualClassSection6} alt='' className='include-text' />
                    <StopMotionSvg
                        shapes={images.decorateLinesSection6}
                        width={186}
                        height={363}
                        interval={500}
                    />
                </div>
                <div className='sub-title'>
                    <Trans i18nKey={'digital-courses.And thousands of digital courses'}>
                        <span className='sub-title'></span>
                    </Trans>
                </div>
            </section>
            {deviceType?.isMobile && (
                <div className="mobile-dash-line" id="mobile-dash-line-4">
                    <DashedDrawedSvg
                        svgWidth="201" svgHeight="197"
                        d="M63.1351 8.67761C115.955 -17.6718 33.0592 123.579 113.817 79.7676C149.15 60.5997 142.91 180.994 132.972 194.073"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-4' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            )}

            {/* section 7 */}
            <section className='section-7' id="section7">
                <div className='text-run'>
                    <Trans i18nKey={'digital-courses.But we really have no intention of getting stuck in 2020'}>
                        <span className='text-run'></span>
                    </Trans>
                </div>
                <div className='sub-title'>
                    <Trans i18nKey="digital-courses.So how do you develop a course with value">
                        So how do you develop a <span className='marked-text'>courses</span> with value
                    </Trans>
                </div>
                <div className='text-run titel3'>
                    <Trans i18nKey={'digital-courses.One that is here to stay'}>
                        <span className='text-run'></span>
                    </Trans>
                </div>
                <div className='drag-unite'>
                    {!deviceType?.isMobile && (
                        <div className='transition-6' id="transition-6">
                            <DashedDrawedSvg
                                svgWidth='168' svgHeight='476' strokeDasharray='940'
                                d='M33.4683 4.9752C189.809 68.7548 -113.009 106.832 131.482 196.346C238.449 235.509 43.527 463.71 1.54452 470.146'
                                trigger='#transition-6' startTrigger="top 85%" endTrigger="bottom center" />
                        </div>
                    )}
                    <div className='drag-contener'>
                        <img src={images.dragCorsServies7} />
                        <div className='drag'></div>
                    </div>
                </div>
            </section>
            {deviceType?.isMobile && (
                <div className="mobile-dash-line" id="mobile-dash-line-5">
                    <DashedDrawedSvg
                        svgWidth="201" svgHeight="196"
                        d="M68.028 2.12112C58.0904 15.2001 51.8502 135.595 87.1827 116.427C167.941 72.6152 85.0454 213.866 137.865 187.517"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-5' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            )}

            {/* section 8 */}
            <section className='section-8' id="section8">
                <div className='text-run'>
                    <Trans i18nKey={'digital-courses.Your content meets our expertise'}>
                        <span className='text-run'></span>
                    </Trans>
                </div>
                <div className='completion-cotenter'>
                    <div className='takePeek'>
                        {images.silsolSection8}
                        <div className='button-container'>
                            {images.peekHere}
                            <ModalOpenButton modalType={'fade'} content={{
                                commonVidoe: 'our-expert',
                                vidoePoster: images.ourExpertiesImg,
                                text: t('digital-courses.Your content meets our expertise')
                            }}
                                triggerButton={onClick =>
                                    <button onClick={onClick} type='button' aria-label='לצפיה בטרנדים החמים' tabIndex="true" className='play-circle-button'>
                                        <FontAwesomeIcon icon={faPlay} />
                                    </button>
                                } />
                        </div>
                    </div>
                    <img src={deviceType?.isMobile ? images.completionSection8Mobile : images.completionSection8} alt='' className='full-size-mobile' />
                </div>
            </section>
            {deviceType?.isMobile && (
                <div className="mobile-dash-line" id="mobile-dash-line-6">
                    <DashedDrawedSvg
                        svgWidth="201" svgHeight="197"
                        d="M63.1351 9.12732C115.955 -17.2221 33.0592 124.029 113.817 80.2173C149.15 61.0494 142.91 181.444 132.972 194.523"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-6' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            )}

            {/* section 9 */}
            <section className='section-9' id='section9'>
                <div>
                    <b>{t('digital-courses.Engagement')}</b>
                    <p className={'text-run'}>{t("digital-courses.It is not a bad word, it is an experience")}</p>
                </div>
                <div>
                    <div className='button-container flex-column full-size-mobile'>
                        <div className='flex'>
                            {images.section9Media.arrow}
                            <ModalOpenButton modalType={'fade'} content={{
                                commonVidoe: 'ENGAGMENT',
                                vidoePoster: images.ENGAGMENTPoster,
                                text: t('vidoes.Interesting presenters are always a great addition')
                            }}
                                triggerButton={onClick =>
                                    <button onClick={onClick} type='button' aria-label='לצפיה בטרנדים החמים' tabIndex="true">
                                        <div className='key'><span className='notes'>לחצו</span></div>
                                        {images.section9Media.tringle}
                                    </button>
                                } />
                        </div>
                        <img src={images.section9Media.hand} alt="" />
                    </div>
                </div>
            </section>
            {deviceType?.isMobile && (
                <div className="mobile-dash-line" id="mobile-dash-line-7">
                    <DashedDrawedSvg
                        svgWidth="84" svgHeight="116"
                        d="M43.5587 3.54688C63.7254 22.3802 96.9587 62.8469 68.5587 74.0469C40.499 85.1127 -27.001 69.8721 19.0596 112.547"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-7' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            )}

            {/* section 10 */}
            <section className='section-10' id='section10'>
                <div className='image'>
                    <StopMotionSvg
                        shapes={images.section10lines}
                        width={310}
                        height={254}
                        interval={500}
                    />
                    <img src={deviceType?.isMobile ? images.section10ImageMobile : images.section10Image} alt="" />
                </div>
                <div className='content'>
                    <p className={'text-run'}>{t("digital-courses.Learning from the best")}</p>
                    <div className='flex'>
                        <ModalOpenButton modalType={'fade'} content={{
                            commonVidoe: 'tovim_byoter',
                            vidoePoster: images.teachersAndPresentorImg,
                            text: t('vidoes.Interesting presenters are always a great addition')
                        }}
                            triggerButton={onClick =>
                                <button onClick={onClick} type='button' aria-label='לצפיה בטרנדים החמים' tabIndex="true" className='play-circle-button'>
                                    <FontAwesomeIcon icon={faPlay} />
                                </button>
                            } />
                        {images.section10Arrow}
                    </div>
                </div>
            </section>

            <section className='section-11' id='section11'>
                {deviceType?.isMobile && <p className={'text-run'}>{t("digital-courses.Games Yes in our school")}</p>}
                <div className='content flex'>
                    {!deviceType?.isMobile && <p className={'text-run'}>{t("digital-courses.Games Yes in our school")}</p>}
                    <ModalOpenButton modalType={'fade'} content={{ commonVidoe: 'lomdot_play', vidoePoster: images.gamesImg }}
                        triggerButton={onClick =>
                            <button onClick={onClick} type='button' aria-label='לצפיה בטרנדים החמים' tabIndex="true" className='button' >
                                {images.section11Media.button}
                            </button>
                        } />
                    {images.section11Media.arrow}
                </div>
                <img src={images.section11Media.gameConsol} alt="" />
            </section>

            {/* section 13 */}
            <section className='section-13' id='section13'>
                <div className='sub-title'>
                    <Trans i18nKey="digital-courses.From idea to first launch working with you end to end">
                        From idea to first launch working with you <span className='marked-text'>end to end:</span>
                    </Trans>
                </div>
                <div className='productions'>
                    {images.section13Boxes.map((item, index) => (
                        <div className="box" key={`item${index}`}>
                            {item.svgElement}
                            <span>{t(`digital-courses.section-14.${item.description}`)}</span>
                        </div>
                    ))}
                </div>
            </section>

            {/* section 14 */}
            <section className='section-14' id='section14'>
                <div className='yalla'>
                    <div className='sub-title'>
                        <Trans i18nKey="digital-courses.Want the formula for a winning digital course">
                            Shall we get started on a new and surprising learning <span className='marked-text'>courseware</span> ?
                        </Trans>
                    </div>
                    <div className='flex'>
                        <CommonButton
                            text={t("digital-courses.Of course")}
                            routePath='/contact-us'
                        />
                        {images.section14Decorations.lines}
                    </div>
                </div>
                <div className='section-14-images'>
                    <img src={images.section14Decorations.image} alt='' className="dinoman" />
                    <img src={images.section14Decorations.tringles} alt='' />
                </div>
            </section>

        </div>
    );


}

export default DigitalCourses;

